var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliverLiningBgBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 986,
    height: 220,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.815 219.937C220.815 98.761 319.086 0.528076 440.308 0.528076C561.53 0.528076 659.801 98.761 659.801 219.937",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.089 219.937C212.089 108.456 310.36 17.9778 431.582 17.9778C552.804 17.9778 651.074 108.456 651.074 219.937",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.361 219.935C203.361 118.147 301.632 35.4249 422.854 35.4249C544.076 35.4249 642.347 118.147 642.347 219.935",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.311 219.937C194.311 127.844 292.581 53.1993 413.803 53.1993C535.025 53.1993 633.296 127.844 633.296 219.937",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.581 219.94C185.581 137.541 283.852 70.6522 405.074 70.6522C526.296 70.6522 624.566 137.541 624.566 219.94",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.856 219.939C176.856 147.234 275.127 88.1003 396.349 88.1003C517.571 88.1003 615.842 147.234 615.842 219.939",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168.127 219.936C168.127 156.925 266.398 105.87 387.62 105.87C508.842 105.87 607.435 156.925 607.435 219.936",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.396 219.936C159.396 166.619 257.666 123.319 378.888 123.319C500.11 123.319 598.381 166.619 598.381 219.936",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.346 219.936C150.346 176.313 248.616 140.768 369.838 140.768C491.06 140.768 589.331 176.313 589.331 219.936",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.619 219.94C141.619 186.011 239.89 158.544 361.112 158.544C482.334 158.544 580.604 186.011 580.604 219.94",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.891 219.941C132.891 195.706 231.161 175.995 352.383 175.995C473.605 175.995 571.876 195.706 571.876 219.941",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.163 219.936C124.163 205.395 222.434 193.439 343.656 193.439C464.878 193.439 563.148 205.395 563.148 219.936",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M440.308 219.94C440.308 98.7646 342.038 0.531616 220.816 0.531616C99.5939 0.531616 1 98.7646 1 219.94",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M449.036 219.94C449.036 108.459 350.765 17.9808 229.543 17.9808C108.321 17.9808 10.0508 108.459 10.0508 219.94",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M458.089 219.939C458.089 118.152 359.818 35.4292 238.596 35.4292C117.374 35.4292 18.7803 118.152 18.7803 219.939",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M466.816 219.941C466.816 127.848 368.546 53.2036 247.324 53.2036C126.102 53.2036 27.5078 127.848 27.5078 219.941",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M475.544 219.938C475.544 137.539 377.273 70.6498 256.051 70.6498C134.829 70.6498 36.2354 137.539 36.2354 219.938",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M484.271 219.941C484.271 147.236 386.001 88.102 264.779 88.102C143.557 88.102 44.9629 147.236 44.9629 219.941",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M493 219.939C493 156.928 394.729 105.873 273.507 105.873C152.285 105.873 54.0146 156.928 54.0146 219.939",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M502.052 219.941C502.052 166.623 403.781 123.323 282.559 123.323C161.337 123.323 62.7432 166.623 62.7432 219.941",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M510.778 219.941C510.778 176.318 412.508 140.773 291.286 140.773C170.064 140.773 71.793 176.318 71.793 219.941",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M519.506 219.942C519.506 186.012 421.235 158.546 300.013 158.546C178.791 158.546 80.5205 186.012 80.5205 219.942",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M528.234 219.941C528.234 195.706 429.964 175.995 308.742 175.995C187.52 175.995 89.249 195.706 89.249 219.941",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 219.942C536.963 205.401 438.692 193.445 317.47 193.445C196.248 193.445 97.9775 205.401 97.9775 219.942",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M545.69 219.938C545.69 215.091 447.42 211.214 326.198 211.214C204.976 211.214 106.705 215.091 106.705 219.938",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M115.431 219.941C115.431 215.094 213.701 211.216 334.923 211.216C418.647 211.216 491.38 213.155 528.555 215.74",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M879.619 219.944C879.619 98.7687 781.348 0.535706 660.126 0.535706C538.904 0.535706 440.634 98.7687 440.634 219.944",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M888.349 219.94C888.349 108.458 790.078 17.9807 668.856 17.9807C547.634 17.9807 449.04 108.458 449.04 219.94",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M897.399 219.944C897.399 118.157 799.129 35.4343 677.907 35.4343C556.685 35.4343 458.414 118.157 458.414 219.944",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M906.127 219.945C906.127 127.852 807.856 53.2078 686.634 53.2078C565.412 53.2078 467.142 127.852 467.142 219.945",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M914.854 219.942C914.854 137.543 816.584 70.6537 695.362 70.6537C574.14 70.6537 475.869 137.543 475.869 219.942",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M923.582 219.945C923.582 147.24 825.311 88.106 704.089 88.106C582.867 88.106 484.597 147.24 484.597 219.945",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M932.309 219.947C932.309 156.935 834.039 105.88 712.817 105.88C591.595 105.88 493.324 156.935 493.324 219.947",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M941.037 219.945C941.037 166.627 842.766 123.327 721.544 123.327C600.322 123.327 502.052 166.627 502.052 219.945",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M950.091 219.945C950.091 176.321 851.82 140.777 730.598 140.777C609.376 140.777 511.105 176.321 511.105 219.945",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M958.817 219.945C958.817 186.016 860.547 158.55 739.325 158.55C618.103 158.55 519.832 186.016 519.832 219.945",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M967.546 219.948C967.546 195.713 869.275 176.002 748.053 176.002C626.831 176.002 528.561 195.713 528.561 219.948",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M976.273 219.945C976.273 205.404 878.003 193.448 756.781 193.448C635.559 193.448 537.288 205.404 537.288 219.945",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M985.002 219.943C985.002 215.096 886.731 211.218 765.509 211.218C644.287 211.218 546.017 215.096 546.017 219.943",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M554.742 219.944C554.742 215.097 653.013 211.22 774.235 211.22C857.959 211.22 930.692 213.159 967.867 215.744",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliverLiningBgBottom);
export default __webpack_public_path__ + "static/media/sliver-lining-bg-bottom.16c5418cf245daeeb57891b6142d63c2.svg";
export { ForwardRef as ReactComponent };